import { Navigate } from 'react-router-dom';
import { LocalStorageKey } from '../shared/enums';
import { Pages } from '../shared/enums';
import { isEmpty } from 'lodash'
import { checkPermission } from '../shared/utils';

const RouteValidation = ({ children, isProtected, protection }) => {
    if (isProtected && isEmpty(localStorage.getItem(LocalStorageKey.TOKEN))) {
        return <Navigate to={Pages.Login} />;
    } else if (!checkPermission(protection) && localStorage.getItem(LocalStorageKey.TOKEN)) {
        return <Navigate to={Pages.Default} />;
    }
    else {
        return children;
    }
};

export default RouteValidation;
